(function ($) {
    // require("../../vendor/typed.js/js/typed.js")

    var $typedItem = $(".js-teaser__typed-text");
    
    if (!$typedItem.length) return;

    var text = $typedItem.text();

    Typed.new(".js-teaser__typed-text", {
        strings: [text],
        typeSpeed: 10
    });
})(jQuery);


// WEBPACK FOOTER //
// ./common.blocks/teaser/teaser.js